import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useContext } from "react";

export type InactivityProps = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
};
const InactivityContext = createContext<InactivityProps>({
  isVisible: false,
  setIsVisible: () => null,
});

type Props = {
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
};

export const InactivityProvider = ({
  children,
  isVisible,
  setIsVisible,
}: Props) => {
  return (
    <InactivityContext.Provider value={{ isVisible, setIsVisible }}>
      {children}
    </InactivityContext.Provider>
  );
};

export const useInactivity = () => {
  return useContext(InactivityContext);
};
